import { localDay, tariffLines, trMoney, type ServiceTariff } from '@wms/domain';

/**
 * The fixed fees of a price list as the website words them: the graduated order fee by its steps,
 * storage per m³ and per pallet per month with what a day of `on`'s month costs, the box fee.
 */
export function TariffTable({ tariff, on = localDay(new Date()), compact = false }: { tariff: ServiceTariff; on?: string; compact?: boolean }) {
  return (
    <table className={compact ? 't tiers compact' : 't'}>
      <tbody>
        {tariffLines(tariff, on).map((l) => (
          <tr key={l.key}>
            <td>
              {l.label}
              {l.note && (
                <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>
                  {l.note}
                </div>
              )}
            </td>
            <td className="num" style={{ verticalAlign: 'top', whiteSpace: l.steps ? 'nowrap' : undefined }}>
              {l.steps
                ? l.steps.map((s) => (
                    <div key={s.text}>
                      {s.text}: <b>{trMoney(s.price)} ₺</b>
                    </div>
                  ))
                : l.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
